export function calcPercentFloor(value: number, percent: number) {
  let result = value * (percent / 100);
  return Math.floor(result);
}
